var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

import { PhoneNumberUtil } from 'libphonenumber';

var phoneUtils = PhoneNumberUtil.getInstance();

var PRIMARY_PHONE_TYPE_MAP = {
    home: 'homeNumber',
    mobile: 'cellNumber',
    work: 'workNumber'
};

var PolicyContactsCtrl = function () {
    function PolicyContactsCtrl(InsuranceSuiteMetadata, $filter, defaultLocaleDetails, ContactService) {
        _classCallCheck(this, PolicyContactsCtrl);

        this._rolesTypeList = InsuranceSuiteMetadata.get('pc').types.getTypelist('PolicyContactRole');
        this._filter = $filter;
        this._defaultLocaleDetails = defaultLocaleDetails;
        this._contactsService = ContactService;
    }

    _createClass(PolicyContactsCtrl, [{
        key: 'getPrimaryPhoneNumber',
        value: function getPrimaryPhoneNumber(contact) {
            var phoneNumber = contact[PRIMARY_PHONE_TYPE_MAP[contact.primaryPhoneType]];
            if (!phoneNumber) return null;
            try {
                return phoneUtils.formatNational(phoneNumber, this._defaultLocaleDetails.countryCode);
            } catch (e) {
                return phoneNumber;
            }
        }
    }, {
        key: 'assignContact',
        value: function assignContact(publicId) {
            this._contactsService.assignContact(publicId);
        }

        // noinspection JSUnusedGlobalSymbols

    }, {
        key: 'getRoleName',
        value: function getRoleName(roleCode) {
            return this._filter('translate')('gateway.contacts.common.views.policy.roles.' + this._rolesTypeList.getCode(roleCode).name);
        }
    }]);

    return PolicyContactsCtrl;
}();

PolicyContactsCtrl.$inject = ['InsuranceSuiteMetadata', '$filter', 'defaultLocaleDetails', 'ContactService'];

export default PolicyContactsCtrl;


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/contacts/common/components/PolicyContacts/PolicyContactsCtrl.js
// module id = 1626
// module chunks = 0